var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"合作项目介绍","visible":true,"width":"1000px","close-on-click-modal":false,"close-on-press-escape":false,"before-close":() => {
      _vm.handleClose(false)
    },"append-to-body":""}},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"view-title"},[_vm._v("合作项目介绍")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }